import { ExpiryAlerts, ExpiryAlertsResponse } from 'domain/notification';
import { urlBaseApi } from 'global';
import { RequestMethod } from 'shared/domain/http/request-method';
import { AppError } from 'shared/utils/app-error';
import { getRequestOptions } from 'shared/utils/request-options';
import { fetch } from './global-interceptor';
import { expiryAlertsMapper } from './mapper/notification.mapper';

const getExpiryAlerts = async (): Promise<ExpiryAlerts> => {
  const response = await fetch(`${urlBaseApi}/report/expiry-alerts`, {
    method: RequestMethod.Post,
    ...getRequestOptions(),
  });
  const result = await response.json();
  if (response.ok) {
    return expiryAlertsMapper(result as ExpiryAlertsResponse);
  }

  throw new AppError({ ...result, status: response.status });
};

export const RequestNotification = {
  getExpiryAlerts,
};
